/* me-reveal.js — révèle les éléments .me-reveal au scroll (IntersectionObserver).
   Fallback : tout est révélé au load après 2,5s si l'observer n'a pas tourné. */
(function () {
  var io;
  function countUp(el) {
    var target = parseFloat(el.getAttribute('data-count')) || 0;
    var plain = el.getAttribute('data-count-fmt') === 'plain';
    var dur = 1300, start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      var val = Math.round(target * eased);
      el.textContent = plain ? String(val) : val.toLocaleString('fr-FR');
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  function reveal(el) {
    el.classList.add('is-in');
    el.querySelectorAll('[data-count]').forEach(function (c) {
      if (!c.__counted) { c.__counted = true; countUp(c); }
    });
  }
  function init() {
    var els = document.querySelectorAll('.me-reveal:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(reveal);
      return;
    }
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { io.observe(el); });
    window.__meRevealReady = true;
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('load', function () {
    setTimeout(function () {
      document.querySelectorAll('.me-reveal:not(.is-in)').forEach(reveal);
    }, 2500);
  });
})();
